import { render, staticRenderFns } from "./ReviewsSummary.vue?vue&type=template&id=63e5753c&scoped=true&"
import script from "./ReviewsSummary.vue?vue&type=script&lang=js&"
export * from "./ReviewsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSummary.vue?vue&type=style&index=0&id=63e5753c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5753c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDivider,VProgressCircular})
